<button class="close" mat-button (click)="close()">X</button>
<h3 mat-dialog-title>Create a Company Record.</h3>

<mat-dialog-content class="change-bg">
    <form [formGroup]="newCompanyData" >
        <mat-form-field appearance="fill">
            <mat-label>Company Name</mat-label>
            <input matInput formControlName="companyName" required >
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
            <mat-label>Country</mat-label>
            <input matInput formControlName="country" required >
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
            <mat-label>Country Code</mat-label>
            <input matInput formControlName="countryCode" required >
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
            <mat-label>Branch Code</mat-label>
            <input matInput formControlName="branchCode" required >
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
            <mat-label>SID</mat-label>
            <input matInput formControlName="sid"  >
        </mat-form-field>
        <br>
        <mat-form-field appearance="fill">
            <mat-label>Secret</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" formControlName="secret" >
            <button mat-icon-button matSuffix (click)="hide = !hide" >
            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            </button>
        </mat-form-field>
        <br>
        <mat-slide-toggle [ngModelOptions]="{standalone: true}" formControlName="distinctUser" >
            Distinct user
        </mat-slide-toggle>
    </form>
    
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button mat-primary" (click)="save()">Save</button>
</mat-dialog-actions>